// Sets ErrorState on validation before each individual step proceeds

const ErrorStateActions = {
  SET_ERROR_STATE: 'ErrorState.SET_ERROR_STATE',
  RESET_ERROR_STATE: 'ErrorState.RESET_ERROR_STATE',
};

export default ErrorStateActions;
